exports.onClientEntry = () => {
  if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    return true
  }

  return [0, 0]
}

exports.onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && !location.hash) {
    window.scrollTo(0, 0)
  }

  if (process.env.NODE_ENV !== 'production') {
    return
  }

  setTimeout(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'gatsby-route-change' })
  }, 50)
}
